const selector = '.js-govflanders-widget';

function initGovFlandersWidgets() {
    const mountElements = [...document.querySelectorAll(selector)];

    if (mountElements) {
        mountElements.forEach((mountElement) => {
            mountWidget(mountElement);
        });
    }
}

function mountWidget(mountElement) {
    const { url } = mountElement.dataset;

    window.vl.widget.client.bootstrap(url)
        .then((widget) => widget
            .setMountElement(mountElement)
            .mount())
        .catch(console.error.bind(console));
}

export {
    initGovFlandersWidgets,
};
